// extracted by mini-css-extract-plugin
module.exports = {"searchPanel_wrapper":"searchPanel_wrapper--3HRGX","breadcrumb":"breadcrumb--1pkxv","anchor":"anchor--14bpN","anchorText":"anchorText--xfLNA"};